import * as React from 'react';
import { useCateringLocations } from 'catering/hooks/query';
import { useGoToPath } from 'catering/hooks/navigation';
import { buildOrderSettingsPath } from 'catering/helpers/paths';

export function useRedirectToOrderSettingsForSingleLocation() {
  const { data: cateringLocations } = useCateringLocations();
  const { go } = useGoToPath();

  React.useEffect(() => {
    if (cateringLocations && cateringLocations.length === 1) {
      const locationSlug = cateringLocations[0].location.slug;
      const path = buildOrderSettingsPath({ locationSlug });
      go({ path, isRedirect: true });
    }
  }, [cateringLocations]);
}
